import React, { createContext, useReducer } from "react";

const initialState = {
  linkToken: null,
  linkSuccess: false,
  accessToken: localStorage.getItem("access_token"),
};

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case "SET_LINK_TOKEN":
      return { ...state, linkToken: action.payload };
    case "SET_SUCCESS":
      return { ...state, linkSuccess: true };
    case "SET_ACCESS_TOKEN":
      return { ...state, accessToken: action.payload, linkSuccess: true };
    case "LOGOUT":
      return { ...state, accessToken: null, linkSuccess: false };
    default:
      return state;
  }
};

export const PlaidContext = createContext<any>(null);

export const PlaidProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PlaidContext.Provider value={{ ...state, dispatch }}>
      {children}
    </PlaidContext.Provider>
  );
};